class DownloadService {
  async downloadFile(url: string) {
    const response = await fetch(url);
    return await response.blob();
  }
}

const downloadService = new DownloadService();
export default downloadService;
